import state from './moduleCodesState.js'
import mutations from './moduleCodesMutations.js'
import actions from './moduleCodesActions.js'
import getters from './moduleCodesGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
